var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAcabados(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-paint-8090328",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.043,
    height: 58.044,
    viewBox: "0 0 58.043 58.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7576",
    "data-name": "Path 7576",
    d: "M37.571,46.277a2.9,2.9,0,0,1,2.9,2.9V65.142a2.9,2.9,0,0,1-2.9,2.9H33.218a2.9,2.9,0,0,1-2.9-2.9V49.18a2.9,2.9,0,0,1,2.9-2.9h1.088V39.022A3.989,3.989,0,0,1,38.3,35.031H64.053a1.816,1.816,0,0,0,1.814-1.814V21.609a1.816,1.816,0,0,0-1.814-1.814H60.788V23.06a4.354,4.354,0,0,1-4.353,4.353H14.353A4.354,4.354,0,0,1,10,23.06V14.353A4.354,4.354,0,0,1,14.353,10H56.435a4.354,4.354,0,0,1,4.353,4.353v3.265h3.265a3.989,3.989,0,0,1,3.991,3.991V33.218a3.989,3.989,0,0,1-3.991,3.991H38.3a1.816,1.816,0,0,0-1.814,1.814v7.255Z",
    transform: "translate(-10 -10)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAcabados);
export default __webpack_public_path__ + "static/media/icon_acabados.cd6b7f02484da11a973157f9111a2ca0.svg";
export { ForwardRef as ReactComponent };